export default __webpack_public_path__ + "KaTeX_Main-BoldItalic.7649d52f66dfd41d2cee9aaaa0019ccd.woff";